import { render, staticRenderFns } from "./SiteStatistic.vue?vue&type=template&id=48682883&"
import script from "./SiteStatistic.vue?vue&type=script&lang=js&"
export * from "./SiteStatistic.vue?vue&type=script&lang=js&"
import style0 from "./SiteStatistic.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\001.src\\003.aikl_wrokspace\\aikl_v2_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48682883')) {
      api.createRecord('48682883', component.options)
    } else {
      api.reload('48682883', component.options)
    }
    module.hot.accept("./SiteStatistic.vue?vue&type=template&id=48682883&", function () {
      api.rerender('48682883', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/biz/SiteStatistic.vue"
export default component.exports